// Risk assessment subsection form field enum
export enum RiskAssessmentFormField {
  RISK_ASSESSMENT_HOSPITALIZATION_RISK = 'medicalBackground/riskAssessment/hospitalizationRisk',
  RISK_ASSESSMENT_HOSPITALIZATION_RISK_FACTORS = 'medicalBackground/riskAssessment/hospitalizationRiskFactors',
  RISK_ASSESSMENT_HOSPITALIZATION_RISK_FACTORS_OTHER = 'medicalBackground/riskAssessment/hospitalizationRiskFactorsOther',
  RISK_ASSESSMENT_TRIAGE_CODE = 'medicalBackground/riskAssessment/triageCode',
  RISK_ASSESSMENT_EMERGENCY_PLAN = 'medicalBackground/riskAssessment/emergencyPlan',
  RISK_ASSESSMENT_SAFE_ROOM = 'medicalBackground/riskAssessment/safeRoom',
  RISK_ASSESSMENT_FIRE_ASSESSMENT_OXYGEN = 'medicalBackground/riskAssessment/fireAssessmentOxygen',
  RISK_ASSESSMENT_FIRE_SAFETY_PRECAUTIONS = 'medicalBackground/riskAssessment/fireSafetyPrecautions',
  RISK_ASSESSMENT_HOMEBOUND_STATUS = 'medicalBackground/riskAssessment/homeboundStatus',
  RISK_ASSESSMENT_INFECTION_RISK = 'medicalBackground/riskAssessment/infectionRisk',
  RISK_ASSESSMENT_INFECTION_RISK_FACTORS = 'medicalBackground/riskAssessment/infectionRiskFactors',
  RISK_ASSESSMENT_INFECTION_RISK_FACTORS_OTHER = 'medicalBackground/riskAssessment/infectionRiskFactorsOther',
  RISK_ASSESSMENT_FALL_RISK = 'medicalBackground/riskAssessment/fallRisk',
  RISK_ASSESSMENT_FALL_RISK_FACTORS = 'medicalBackground/riskAssessment/fallRiskFactors',
  RISK_ASSESSMENT_FALL_RISK_FACTORS_OTHER = 'medicalBackground/riskAssessment/fallRiskFactorsOther',
  RISK_ASSESSMENT_FALL_RISK_ASSESSMENT = 'medicalBackground/riskAssessment/fallRiskAssessment',
  RISK_ASSESSMENT_FINANCE_RISK = 'medicalBackground/riskAssessment/financeRisk',
  RISK_ASSESSMENT_FINANCE_RISK_OTHER = 'medicalBackground/riskAssessment/financeRiskOther',
  RISK_ASSESSMENT_ENVIRONMENT_SAFETY = 'medicalBackground/riskAssessment/environmentSafety',
  RISK_ASSESSMENT_NURSE_SAFETY_RISKS = 'medicalBackground/riskAssessment/nurseSafetyRisks',
  RISK_ASSESSMENT_SAFETY_MEASURES = 'medicalBackground/riskAssessment/safetyMeasures',
  RISK_ASSESSMENT_NOTES = 'medicalBackground/riskAssessment/notes'
}
